import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "accordion-item border-0 rounded-0" }
const _hoisted_3 = ["data-bs-target"]
const _hoisted_4 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_6 = ["id", "data-bs-parent"]
const _hoisted_7 = { class: "accordion-body border-0 py-15 py-sm-20 p-md-25 py-sm-25 py-lg-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion border-0",
    id: _ctx.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0 collapsed p-15 p-sm-20 p-sm-25 p-lg-30 pe-50",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": `#${_ctx.id}-tab`,
        "aria-expanded": "false",
        "aria-controls": "content-permission-tab"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.title), 1 /* TEXT */)
            ])
          ])
        ])
      ], 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", {
        id: `${_ctx.id}-tab`,
        class: "accordion-collapse collapse border-0",
        "data-bs-parent": `#${_ctx.id}`
      }, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 8 /* PROPS */, _hoisted_6)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}